import axios from "axios";

export default function checkIntegrationSettingSetup() {
  return new Promise((resolve, reject) => {
    axios
      .get(`/account/api/v1/check-dksh-integration-is-setup`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
